export const taxCategories = [
  { id: "c290a139-da9c-4e00-88fd-9517b5b44eef", name: "IVA del 4%" },
  { id: "f5094c51-3e22-42b8-9f63-b0c8618a120e", name: "IVA del 10%" },
  { id: "169f8946-797e-41b0-a643-1cb62e61fb31", name: "IVA del 21%" },
  { id: "98b5c6b6-9138-4592-a9c6-7f1ebb54bd15", name: "Exempt" },
]
